import React, { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import MyModal from '../../../UI/modal/MyModal'
import SupplyOrderForm from './SupplyOrderForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const SupplyOrderFormAdd = ({ supplyOrder }) => {

	const [open, setOpen] = useState(false)
  
  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                supplyOrder ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={supplyOrder ? 'Редагувати заявку' : 'Додати заявку'}
            disableClickOutside={true}
            content={
                <SupplyOrderForm
                    supplyOrderBd={supplyOrder}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SupplyOrderFormAdd